'use strict';

const createErrorNotification = require('../components/errorNotification');
const formHelpers = require('../checkout/formErrors');

const { CLASSES } = require('../utils/globals');
const SELECTORS = {
    body: 'body',
    createEventForm: '.js-create-event-form-request',
    eventTypeSelect: '.js-event-type-select',
    displayForWeddingType: '.js-display-for-wedding-type',
    displayForQuinceañeraType: '.js-display-for-quinceanera-type',
    generalErrorContainer: '.error-messaging',
    promoCodeInput: '.js-promo-code-input',
    promoDetails: '.js-promo-details',
    applyPromoBtn: '.js-apply-promo-code',
    removePromoBtn: '.js-remove-promo-code',
    promoDetailsModalContent: '.js-promo-details-modal-content',
    inputFieldWrapper: '.js-field-wrapper',
    invalidFieldMessage: '.js-invalid-message',
    selectState: '.js-select-state',
    selectAddress: '.js-store-address-selector',
    nextButton: '.js-form-next-btn',
    phoneFieldSelector: '.js-spouse-1-phone',
    spouseSMSconsentInput: '.js-spouse-sms-consent',
    spouse2EmailField: '.js-spouse-2-email',
    spouseSuitOrTuxCheckbox: '.js-spouse-suit-or-tux-checkbox',
    backBtn: '.js-event-back',
    eventCard: '.event-card',
    eventHeading: '.js-event-heading',
    applyPromoModal: '.js-apply-promo-modal',
    applyPromoModalSubmit: '.js-apply-promo-submit',
    validatedPromoInput: '.js-validated-promo-code'
}

const getInputField = (element) => $(element).find('.js-input-field, .js-select, .js-select-dropdown-below');


/**
 * Init page events
 * @returns {void}
 */
function init() {
    $(SELECTORS.createEventForm).on('submit', handleCreateEventFormSubmit);

    // Event on Event Type select change
    $(SELECTORS.body).on('select2:select', SELECTORS.eventTypeSelect, function () {
        let eventType = $(this).val().toLocaleLowerCase();
        handleFormFieldsDisplay(eventType);
    });

    // On page render
    handleFormFieldsDisplay($(SELECTORS.eventTypeSelect).val().toLocaleLowerCase());

    // Validate Promo Code
    $(SELECTORS.promoCodeInput).on('input', clearPromoCodeForm);
    $(SELECTORS.body).on('click', SELECTORS.applyPromoBtn, validatePromoCode);
    $(SELECTORS.body).on('keydown', SELECTORS.promoCodeInput, validatePromoCode);
    $(SELECTORS.body).on('click', SELECTORS.removePromoBtn, removePromoCode);

    $(SELECTORS.spouseSuitOrTuxCheckbox).on('change', handleSpouseSuitOrTuxCheckboxChange);

    //select state
    $(SELECTORS.selectState).on('click', selectState);
    $(SELECTORS.selectAddress).on('click', selectAddress);
    $(SELECTORS.nextButton).on('click', proceedToForm);
    // $(SELECTORS.body).on('click', SELECTORS.loadMoreLocationsBtn, loadMoreLocations);

    //phone
    $(SELECTORS.phoneFieldSelector).on('focusin', handlePhoneFieldFocusIn);
    $(SELECTORS.phoneFieldSelector).on('focusout', handleFormatPhoneNumber);
    $(SELECTORS.phoneFieldSelector).each(function() {
        const fakeEvent = {
            target: this,
            preventDefault: function() {} // no-op since there's no default behavior to prevent here
        };

        handleFormatPhoneNumber(fakeEvent);
    });

    $(document).on('click change', 'input, select', function() {
        $(SELECTORS.createEventForm).find('button[type="submit"]').prop('disabled', false);
    });

    $(SELECTORS.backBtn).on('click', handleBackButton);
    $(SELECTORS.body).on('click', SELECTORS.applyPromoModalSubmit, function() {
        $(this).data('override', true);
        $(SELECTORS.applyPromoModal).modal('hide');
    });
}

/**
 * Select Address
 */

const selectAddress = (e) => {
    e.preventDefault();

    let $this = $(e.currentTarget);

    // reset all selectors
    $(SELECTORS.selectAddress).removeClass('selected');

    // add class to this element
    $($this).addClass('selected');

    // update form input
    let storeNo = $($this).data('id');
    $('.js-selected-store').val(storeNo);

    //enable next btn
    $(SELECTORS.nextButton).prop("disabled", false);
}

const proceedToForm = (e) => {
    e.preventDefault();

    // show form selector screen
    $('.js-event-card1').addClass(CLASSES.hide);
    $('.js-event-card2').removeClass(CLASSES.hide);
    $(SELECTORS.backBtn).removeClass(CLASSES.hide);
}

/**
 * Select state
 */

const selectState = (e) => {
    e.preventDefault();

    let $selected = $(e.target);
    let selectedVal = $($selected).data('statecode');

    // show bounce message screen
    if (selectedVal === '') {
        $('.js-state-container').addClass(CLASSES.hide);
        $('.js-bounce-screen').removeClass(CLASSES.hide);
        $(SELECTORS.eventHeading).addClass(CLASSES.hide);
    } else {
        // show store selector screen
        $('.js-event-card1').addClass(CLASSES.hide);
        $('.js-selected-state').text($($selected).text());
        $('.js-event-card2').removeClass(CLASSES.hide);

        // update state selected form
        $('.js-selected-state').val($($selected ).text());
        $(SELECTORS.backBtn).removeClass(CLASSES.hide);
        $(SELECTORS.eventHeading).removeClass(CLASSES.hide);
    }
}

/**
 * Ajax call to 'Event-Create' endpoint
 * @returns {void}
 */
const handleCreateEventFormSubmit = (e) => {
    e.preventDefault();

    let hasPendingPromo = hasPendingPromoToApply();

    if (hasPendingPromo) {
        return;
    }

    const $form = $(e.target);
    formHelpers.clearPreviousErrors($form);
    $form.find('button[type="submit"]').prop('disabled',true);

    $(SELECTORS.spouseSMSconsentInput).val($(SELECTORS.spouseSMSconsentInput).is(':checked'));
    let spouseSMSconsentInputValue = $(SELECTORS.spouseSMSconsentInput).serialize();

    let spouseSuitOrTuxCheckboxInputValues = $(SELECTORS.spouseSuitOrTuxCheckbox).serialize();

    $.spinner().start();
    $.ajax({
        url: $form.attr('action'),
        type: $form.attr('method'),
        data: $form.serialize() + '&' + spouseSMSconsentInputValue + '&' + spouseSuitOrTuxCheckboxInputValues,
        dataType: 'json',
        async: false,
        success: (response) => {

            if (response.fieldErrors && response.fieldErrors.length) {
                response.fieldErrors.forEach(function (error) {
                    if (Object.keys(error).length) {
                        formHelpers.loadFormErrors($form, error);
                    }
                });
            }

            if (response.success && response.redirectUrl) {
                window.location.replace(response.redirectUrl);
            }

            if ((response.error || !response.success) && response.errorMessage) {
                createErrorNotification($(SELECTORS.generalErrorContainer), response.errorMessage);
            }

            $.spinner().stop();
        },
        error: (error) => {
            if (error.errorMessage) {
                createErrorNotification($(SELECTORS.generalErrorContainer), error.errorMessage);
            }

            $.spinner().stop();
        }
    });

    return false;
}

/**
 * Display/Hide form fields and change required field
 * attributes depending on the Event Type
 * @param {String} eventType - event type
 * @returns {void}
 */
const handleFormFieldsDisplay = (eventType) => {
    getInputField(SELECTORS.spouse2EmailField).prop('required', false);

    if (!eventType || eventType === '' || (eventType && eventType !== 'wedding' && eventType !== 'quinceañera' && eventType !== 'quince' && eventType !== 'quinceanera')) {
        $(SELECTORS.displayForWeddingType).addClass(CLASSES.hide);
        $(SELECTORS.displayForQuinceañeraType).addClass(CLASSES.hide);

        getInputField(SELECTORS.displayForWeddingType).prop('required', false);
        getInputField(SELECTORS.displayForQuinceañeraType).prop('required', false);

        return;
    }

    if (eventType === 'wedding') {
        $(SELECTORS.displayForWeddingType).removeClass(CLASSES.hide);
        $(SELECTORS.displayForQuinceañeraType).addClass(CLASSES.hide);

        if ($(SELECTORS.displayForWeddingType).hasClass('required')) {
            getInputField(SELECTORS.displayForWeddingType).prop('required', true);
        }

        getInputField(SELECTORS.displayForQuinceañeraType).prop('required', false);
    }

    if (eventType == 'quinceañera' || eventType == 'quince' || eventType == 'quinceanera') {
        $(SELECTORS.displayForQuinceañeraType).removeClass(CLASSES.hide);
        $(SELECTORS.displayForWeddingType).addClass(CLASSES.hide);

        if ($(SELECTORS.displayForQuinceañeraType).hasClass('required')) {
            getInputField(SELECTORS.displayForQuinceañeraType).prop('required', true);
        }

        getInputField(SELECTORS.displayForWeddingType).prop('required', false);
    }
}

const removePromoCode = (e) => {
    const $button = $(e.target);
    const $promoInput = $(SELECTORS.promoCodeInput);

    $button
        .removeClass('js-remove-promo-code')
        .addClass('js-apply-promo-code')
        .html($button.data('apply-label'));

    $promoInput
        .val('')
        .attr('readonly', false)
        .trigger('focus');

    $promoInput.parent().removeClass(CLASSES.isValid);

    var $promoDetails = $(SELECTORS.promoDetails);
    $promoDetails.addClass(CLASSES.hide);
    $(SELECTORS.promoDetailsModalContent).html('');
    $(SELECTORS.validatedPromoInput).val('');
}

/**
 * Ajax call to 'Event-ValidatePromoCode' endpoint to check if promo code is valid
 * @returns {void}
 */
const validatePromoCode = (e) => {
    if (e.type === 'keydown') {
        if (e.key.toLocaleLowerCase() === 'enter') {
            e.preventDefault();
        } else {
            return;
        }
    }

    const $promoInput = $(SELECTORS.promoCodeInput);
    const promoCode = $promoInput.val();
    const $button = $(SELECTORS.applyPromoBtn)

    if (!promoCode || !promoCode.length) {
        return;
    }

    $.spinner().start();
    $.ajax({
        url: $promoInput.attr('action'),
        type: 'POST',
        data: {
            promoCode
        },
        dataType: 'json',
        success: (response) => {
            var $promoDetails = $(SELECTORS.promoDetails);
            if (response.success) {
                $promoInput.parent().addClass(CLASSES.isValid);
                $promoInput.attr('readonly', true);
                $button
                    .removeClass('js-apply-promo-code')
                    .addClass('js-remove-promo-code')
                    .html($button.data('remove-label'));
                if (response.promoDetails) {
                    $promoDetails.removeClass(CLASSES.hide);
                    $(SELECTORS.promoDetailsModalContent).html(response.promoDetails)
                } else {
                    $promoDetails.addClass(CLASSES.hide);
                    $(SELECTORS.promoDetailsModalContent).html('');
                }

                $(SELECTORS.validatedPromoInput).val(true);
            }

            if (response.error) {
                $promoInput.parent().removeClass(CLASSES.isValid);
                $promoInput.val('');

                $('body').trigger('field:error', {
                    element: $promoInput,
                    message: response.errorMessage
                });

                $promoDetails.addClass(CLASSES.hide);
                $(SELECTORS.promoDetailsModalContent).html('');
                $(SELECTORS.validatedPromoInput).val('');
            }

            $.spinner().stop();
        },
        error: () => {
            $.spinner().stop();
        }
    });
}

/**
 * Clears Form on input
 * @returns {void}
 */
const clearPromoCodeForm = () => {
    $(SELECTORS.promoCodeInput).parent().removeClass(CLASSES.isInvalid);
    $(SELECTORS.promoCodeInput).closest(SELECTORS.inputFieldWrapper).find(SELECTORS.invalidFieldMessage).empty();
}

// const loadMoreLocations = (e) => {
//     let $this = $(e.currentTarget);
//     $this.hide();
//     $(SELECTORS.storeWrapper).addClass('pr-2');
//     $(SELECTORS.selectAddress).parent().removeClass(CLASSES.hide);
// }

/**
 * Format phone number on focus out
 * @returns {void}
 */
const handleFormatPhoneNumber = (e) => {
    e.preventDefault();

    const $phoneInput = $(e.target);
    const phoneValue = $phoneInput.val();

    $phoneInput.attr('maxlength', 12);
    if (!phoneValue || !phoneValue.length) {
        return;
    }

    let formattedPhone = formatPhoneNumber(phoneValue);
    if (formattedPhone) {
        $phoneInput.val(formattedPhone);
    }
}

/**
 * Handle spouse will need "Suit or Tux" checkbox change
 * @returns {void}
 */
const handleSpouseSuitOrTuxCheckboxChange = (e) => {
    e.preventDefault();

    const $spouseSuitOrTuxCheckbox = $(e.target);

    $spouseSuitOrTuxCheckbox.val($spouseSuitOrTuxCheckbox.is(':checked'));
    if ($spouseSuitOrTuxCheckbox.hasClass('spouse2')) {
        $(SELECTORS.spouse2EmailField)[$spouseSuitOrTuxCheckbox.is(':checked') ? 'removeClass' : 'addClass'](CLASSES.hide);
        getInputField(SELECTORS.spouse2EmailField).prop('required', $spouseSuitOrTuxCheckbox.is(':checked'));
    }
}

/**
 * handle phone field focus in to remove dashes
 * @returns {void}
 */
const handlePhoneFieldFocusIn = (e) => {
    const $phoneInput = $(e.target);
    const phoneValue = $phoneInput.val();

    $phoneInput.attr('maxlength', 10);
    if (!phoneValue || !phoneValue.length) {
        return;
    }

    $phoneInput.val(phoneValue.replace(/[- ]/g, ''));
}

const handleBackButton = (e) => {
    const $this = $(e.target);
    const currentCard = $(SELECTORS.eventCard).not('.d-none');
    const currentPage = parseInt(currentCard.data('card-page')) - 1 ;

    $('.js-event-card' + currentPage).removeClass(CLASSES.hide);
    $(currentCard).addClass(CLASSES.hide);
    $this.addClass(CLASSES.hide);
}

/**
 * Formats phone number to XXX-YYY-ZZZZ
 * @param {string} phone - User's phone number
 * @return {string} - formated phone number
 */
function formatPhoneNumber(phone) {
    //normalize string and remove all unnecessary characters
    phone = phone.replace(/[^\d]/g, "");
    //check if number length equals to 10
    if (phone.length == 10) {
        //reformat and return phone number
        return phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
    }

    if (phone.length === 11 && phone.charAt(0) === '1') {
        return phone.replace(/1(\d{3})(\d{3})(\d{4})/, '1-$1-$2-$3');
    }

    return null;
}

function hasPendingPromoToApply() {
    let hasPendingPromo = false;
    const $promoInput = $(SELECTORS.promoCodeInput);
    const $applyPromoModalSubmit = $(SELECTORS.applyPromoModalSubmit);
    const override = $applyPromoModalSubmit.data('override');
    if ($promoInput.val().trim() && $(SELECTORS.applyPromoBtn).length > 0 && !override) {
        $(SELECTORS.applyPromoModal).modal('show');
        hasPendingPromo = true;
    }

    return hasPendingPromo;
}

module.exports = {
    init: init
};
